import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ar } from '@/i18n/locales/ar';
import { en } from '@/i18n/locales/en';
import { DEFAULT_LOCALE, LOCALE_STORAGE_KEY, readStoredLocale, type AppLocale } from '@/i18n/types';

export const I18N_NAMESPACES = [
  'common',
  'nav',
  'userMenu',
  'auth',
  'settings',
  'post',
  'class',
  'messages',
  'calendar',
  'push',
  'profile',
  'notifications',
  'prime',
  'feed',
  'explore',
  'createPost',
  'search',
  'payments',
  'reportCards',
  'grades',
  'behaviour',
  'attendance',
  'resources',
  'progress',
  'globalCalendar',
  'questionResponses',
  'tutorPackages',
  'admissions',
] as const;

export type I18nNamespace = (typeof I18N_NAMESPACES)[number];

export function applyDocumentLocale(locale: AppLocale): void {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = locale;
  // The authenticated app keeps its established LTR chrome. Public surfaces
  // that support a full RTL layout set their own `dir` boundary.
  document.documentElement.dir = 'ltr';
}

const initialLocale = readStoredLocale();
applyDocumentLocale(initialLocale);

void i18n.use(initReactI18next).init({
  resources: {
    en,
    ar,
  },
  lng: initialLocale,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: ['en', 'ar'],
  ns: [...I18N_NAMESPACES],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export async function setAppLocale(locale: AppLocale): Promise<void> {
  await i18n.changeLanguage(locale);
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  }
  applyDocumentLocale(locale);
}

export default i18n;
